/* esm.sh - victory-vendor@37.3.6/d3-scale */
export * from "/*victory-vendor@37.3.6/esnext/d3-scale.mjs";
